function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { WDHVariation } from '../../../../../wdh-foundation/wdh';

/**
 * @memberOf module:wdh-plain-text-spot
 */
var WDHMultiComponentTabNav = /*#__PURE__*/function (_WDHVariation) {
  /**
   * @param className
   * @constructor
   * @augments WDHVariation
   * @inheritDoc
   */
  function WDHMultiComponentTabNav() {
    var _this;
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'multi-component-tab-nav';
    _classCallCheck(this, WDHMultiComponentTabNav);
    _this = _callSuper(this, WDHMultiComponentTabNav, [className]);
    _this.topComponent = null;
    _this.baseTabTexts = [];
    return _this;
  }
  _inherits(WDHMultiComponentTabNav, _WDHVariation);
  return _createClass(WDHMultiComponentTabNav, [{
    key: "init",
    value: function init(component) {
      var $ = window.jQuery;
      var that = this;

      // Here you add the code to initiate your component. This is run once when the page is ready
      this.topComponent = this.topComponent || component;
      if (component !== this.topComponent) {
        this.baseTabTexts.push($(component).text());
        $(this.topComponent).html("".concat($(this.topComponent).html(), "<div class=\"tab\">").concat($(component).text(), "</div>"));
        $(component).next().addClass('plain-text-spot-multi-line-content plain-text-spot-multi-line-content-hide');
        $(component).remove();
      } else {
        this.baseTabTexts.push($(this.topComponent).text());
        $(this.topComponent).html("<div class=\"tab tab--selected\">".concat($(this.topComponent).text(), "</div>"));
        $(component).next().addClass('plain-text-spot-multi-line-content');
      }
      $('.tab', this.topComponent).off('click');
      $('.tab', this.topComponent).on('click', function () {
        $('.plain-text-spot-multi-line-content').addClass('plain-text-spot-multi-line-content-hide');
        var clickedTabIndex = $(this).index();
        $('.tab', that.topComponent).removeClass('tab--selected');
        $(this).addClass('tab--selected');
        var targetContent = $('.plain-text-spot-multi-line-content')[clickedTabIndex];
        $(targetContent).removeClass('plain-text-spot-multi-line-content-hide');
      });
    }

    /**
     * Returns the managed components
     * @returns {Node[]}
     */
  }, {
    key: "getManagedComponents",
    value: function getManagedComponents() {
      return Array.from(document.querySelectorAll('.plain-text-spot-multi-line-content'));
    }
  }, {
    key: "appendTextToTab",
    value: function appendTextToTab(index, text) {
      var tabs = Array.from(this.topComponent.querySelectorAll('.tab'));
      if (index < tabs.length) {
        var tab = tabs[index];
        tab.innerHTML = "".concat(this.baseTabTexts[index]).concat(text);
      }
    }
  }, {
    key: "resize",
    value: function resize(component) {
      // Here you add code to handle the page being resized. This is called every time the page is resized.
    }
  }, {
    key: "scroll",
    value: function scroll(component, scrollTop) {
      // Here you add code to handle the page being scrolled. This is called every time the page is scrolled.
    }
  }]);
}(WDHVariation);
export default WDHMultiComponentTabNav;